import React, { forwardRef, useState } from "react";
import { cn } from "./cn";
import { Input } from "./Field";

/**
 * Bun currency input. Spec: components/forms/CurrencyInput. The $ sits
 * inside the field; numeric input mode. Right-align inside category tables.
 * Wrap in <Field label helper error> like any other control.
 */
const CurrencyInput = forwardRef(function CurrencyInput(
  { error, align = "left", size = "md", formatThousands = false, className, ...props },
  ref
) {
  const [focused, setFocused] = useState(false);
  const formattedProps = formatThousands ? {
    type: "text",
    value: !focused && props.value !== '' && props.value != null && Number.isFinite(Number(props.value))
      ? Number(props.value).toLocaleString('en-US', { maximumFractionDigits: 20 })
      : props.value,
    onFocus: event => { setFocused(true); props.onFocus?.(event); },
    onBlur: event => { setFocused(false); props.onBlur?.(event); },
    onChange: event => {
      event.target.value = event.target.value.replace(/,/g, '');
      props.onChange?.(event);
    },
  } : {};
  return (
    <span className={cn("relative block font-instrument", className)}>
      <span className={cn("pointer-events-none absolute top-1/2 -translate-y-1/2 text-bun-body font-book text-bun-stone", size === "sm" ? "left-2" : "left-3")}>
        $
      </span>
      <Input
        ref={ref}
        inputMode="numeric"
        size={size}
        error={error}
        className={cn(
          size === "sm" ? "pl-[22px]" : "pl-[26px]",
          align === "right" && "text-right"
        )}
        {...props}
        {...formattedProps}
      />
    </span>
  );
});

export default CurrencyInput;
